import React from "react";

const FeaturesSection = ({ features }) => {
  return (
    <div className="mx-auto max-w-7xl grid gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {features.map((feature, idx) => (
          <div
            key={idx}
            className="flex flex-col items-start py-2 lg:py-6 rounded-xl"
          >
            {/* Optional image block or placeholder */}
            {/* 
           <div className="bg-white h-[200px] w-full rounded-lg"></div>
           */}

            <div className="w-full flex flex-col justify-center">
              <h3 className="text-lg text-white font-semibold">
                {feature.title}
              </h3>
              <p className="mt-2 mb-3 text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                {feature.description}
              </p>
              {feature.bullets && idx === 0 && (
                <h3 className="text-white font-semibold mb-2">Examples:</h3>
              )}

              {feature.bullets && (
                <ul className="list-none space-y-2">
                  {feature.bullets.map((bullet, bIdx) => (
                    <li key={bIdx} className="flex items-start gap-2">
                      <span className="w-[10px] h-[10px] mt-[7px] bg-[#5AE600] rounded-sm flex-shrink-0" />
                      <span className="text-[15px] text-white lg:text-[17px] leading-[140%]">
                        {"from" in bullet && "to" in bullet
                          ? `${bullet.from} → ${bullet.to}`
                          : bullet.note}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturesSection;
